import { Howl, Howler } from 'howler';

const audio = {
  sounds: [
    {
      key: 'tap',
      src: '/sounds/tap.mp3',
      volume: 0.2,
      loop: false,
      ref: null,
    }, {
      key: 'swoosh',
      src: '/sounds/swoosh.mp3',
      volume: 1,
      loop: false,
      ref: null,
    }, {
      key: 'youwin',
      src: '/sounds/youwin.mp3',
      volume: 0.2,
      loop: false,
      ref: null,
    }, {
      key: 'game',
      src: '/sounds/game.mp3',
      volume: 0.2,
      loop: true,
      ref: null,
    }, {
      key: 'play',
      src: '/sounds/play.mp3',
      volume: 0.02,
      loop: false,
      ref: null,
    }, {
      key: 'close',
      src: '/sounds/close.mp3',
      volume: 0.1,
      loop: false,
      ref: null,
    },
  ],

  load() {
    audio.sounds.forEach((sound) => {
      sound.ref = new Howl({
        src: [sound.src],
        volume: sound.volume,
        loop: sound.loop,
      });
    });
  },

  get(key) {
    return this.sounds.find((sound) => sound.key === key);
  },

  play(key) {
    if (audio.muted) return;
    audio.get(key).ref.play();
  },

  pause(key) {
    audio.get(key).ref.pause();
  },

  mute() {
    Howler.mute(true);
  },

  unmute() {
    Howler.mute(false);
  },
};

export default audio;
